<div #container *ngIf="active$|async as active" class="navbar__item-container fadeIn">
    <span *ngFor="let status of projectJobStatuses$|async" [id]="'filter-'+status.filter" class="navbar__item" [class.active]="active.filter === status.filter" (click)="selectFilter(status)">
        {{ status.title }}
        <span *ngIf="status.total" class="navbar__item-count">({{ status.total }})</span>
    </span>
</div>
<div #underline class="navbar__underline"></div>
